// extracted by mini-css-extract-plugin
export default {"wrapper":"Ry-z","fullName":"Sy-z"};